import { SaveButton } from "components/Buttons"
import TableComponent from "components/Table"
import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { Col, Input, Row } from "reactstrap"
import { getPlacesReports, getPlacesSummaryReports } from "store/actions"
import Flatpickr from "react-flatpickr"
import favoriteReportsListColumns from "./favoriteReportsListColumns"

const FavoriteReports = ({
  placesReports,
  getPlacesReports,
  placesSummaryReports,
  getPlacesSummaryReports,
  selectedBusinesUnit,
}) => {
  const [showResetButton, setShowResetButton] = useState(false)
  const [searchValue, setSearchValue] = useState("")
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [defaultOrder, setDefaultOrder] = useState({
    o: "favorite_places_count",
    od: "desc",
  })

  useEffect(() => {
    getPlacesReports({
      ...defaultOrder,
      page: 1,
      per_page: 25,
      ...(selectedBusinesUnit?.value
        ? { business_unit_id: selectedBusinesUnit?.value }
        : {}),
      ...(searchValue.trim().length ? { search: searchValue } : {}),
      ...(startDate?.trim().length ? { start: startDate } : {}),
      ...(endDate?.trim().length ? { end: endDate } : {}),
    })
    getPlacesSummaryReports({
      ...(startDate?.trim().length ? { start: startDate } : {}),
      ...(endDate?.trim().length ? { end: endDate } : {}),
    })
  }, [selectedBusinesUnit])

  const handleSearch = () => {
    getPlacesReports({
      ...defaultOrder,
      page: 1,
      per_page: 25,
      ...(selectedBusinesUnit?.value
        ? { business_unit_id: selectedBusinesUnit?.value }
        : {}),
      ...(searchValue.trim().length ? { search: searchValue } : {}),
      ...(startDate?.trim().length ? { start: startDate } : {}),
      ...(endDate?.trim().length ? { end: endDate } : {}),
    })
    getPlacesSummaryReports({
      ...(startDate?.trim().length ? { start: startDate } : {}),
      ...(endDate?.trim().length ? { end: endDate } : {}),
    })
    setShowResetButton(true)
  }

  const handleResetSearch = () => {
    getPlacesReports({
      ...defaultOrder,
      page: 1,
      per_page: 25,
      ...(selectedBusinesUnit?.value
        ? { business_unit_id: selectedBusinesUnit?.value }
        : {}),
    })
    getPlacesSummaryReports({})
    setShowResetButton(false)
    setSearchValue("")
    setStartDate("")
    setEndDate("")
  }

  const handleSort = (type, { sortField, sortOrder }) => {
    getPlacesReports({
      o: sortField,
      od: sortOrder,
      page: 1,
      per_page: 25,
      ...(selectedBusinesUnit?.value
        ? { business_unit_id: selectedBusinesUnit?.value }
        : {}),
      ...(searchValue.trim().length ? { search: searchValue } : {}),
      ...(startDate?.trim().length ? { start: startDate } : {}),
      ...(endDate?.trim().length ? { end: endDate } : {}),
    })
    setDefaultOrder({ o: sortField, od: sortOrder })
  }

  const handlePageChange = page => {
    getPlacesReports({
      ...defaultOrder,
      page: page,
      per_page: 25,
      ...(selectedBusinesUnit?.value
        ? { business_unit_id: selectedBusinesUnit?.value }
        : {}),
      ...(searchValue.trim().length ? { search: searchValue } : {}),
      ...(startDate?.trim().length ? { start: startDate } : {}),
      ...(endDate?.trim().length ? { end: endDate } : {}),
    })
  }

  return (
    <React.Fragment>
      <Row className="my-3 d-flex justify-content-center">
        <Col xs="auto" className="my-1">
          <Input
            placeholder="Place"
            value={searchValue}
            onChange={event => {
              setSearchValue(event.target.value)
            }}
          />
        </Col>
        <Col xs="auto" className="my-1">
          <Flatpickr
            className="form-control bg-white"
            placeholder="Start Date"
            options={{
              altInput: true,
              altFormat: "Y-m-d",
              dateFormat: "Y-m-d",
            }}
            value={startDate}
            onChange={(selectedDates, dateStr) => {
              setStartDate(dateStr)
            }}
          />
        </Col>
        <Col xs="auto" className="my-1">
          <Flatpickr
            className="form-control bg-white"
            placeholder="End Date"
            options={{
              altInput: true,
              altFormat: "Y-m-d",
              dateFormat: "Y-m-d",
            }}
            value={endDate}
            onChange={(selectedDates, dateStr) => {
              setEndDate(dateStr)
            }}
          />
        </Col>
        <Col xs="auto" className="my-1">
          <SaveButton type="button" content="Search" onClick={handleSearch} />
        </Col>
        {showResetButton && (
          <Col xs="auto" className="my-1">
            <SaveButton
              type="button"
              content="Reset"
              onClick={handleResetSearch}
              color="light"
            />
          </Col>
        )}
      </Row>
      <Row className="my-1">
        <Col>
          <h6>
            # of users favoriting places: {placesSummaryReports?.users_count}
          </h6>
        </Col>
      </Row>
      <Row className="my-1">
        <Col>
          <h6>
            # of visitors favoriting places:{" "}
            {placesSummaryReports?.visitors_count}
          </h6>
        </Col>
      </Row>
      <Row className="my-1">
        <Col>
          <h6># of places Favorited: {placesSummaryReports?.places_count}</h6>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          <TableComponent
            columns={favoriteReportsListColumns()}
            data={placesReports?.data}
            paginationData={{
              current_page: placesReports?.current_page,
              last_page: placesReports?.last_page,
              total_items: placesReports?.total,
              items_per_page: placesReports?.per_page,
              from: placesReports?.from,
              to: placesReports?.to,
              first_page: 1,
            }}
            onPageChange={handlePageChange}
            onTableSort={handleSort}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  placesReports: state.PlacesList.placesReports,
  placesSummaryReports: state.PlacesList.placesSummaryReports,
})

const mapDispatchToProps = dispatch => ({
  getPlacesReports: values => dispatch(getPlacesReports(values)),
  getPlacesSummaryReports: values => dispatch(getPlacesSummaryReports(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FavoriteReports)
